<div mat-dialog-title class="title">
    <h2 mat-dialog-title style="color:white">Return Request: {{ data.stageName }}</h2>
    <button (click)="closeDialog()" mat-dialog-close class="close-button" mat-icon-button matSuffix>
        <mat-icon class="close-icon-color">cancel</mat-icon>
    </button>
</div>
<mat-dialog-content>
    <form [formGroup]="reasonForm">
        <mat-form-field appearance="fill" class="full-width" style="width: 100%; min-width: 500px; padding-top:15px;">
            <mat-label>Reason for returning</mat-label>
            <textarea matInput formControlName="reason" rows="4"></textarea>
            <mat-error *ngIf="reasonForm.get('reason')?.hasError('required')">
                Reason is required
            </mat-error>
        </mat-form-field>

        @if(partnerStage){
        <mat-form-field class="fullLength">
            <mat-label>Should the Accounts Team permanently reverse and reject this request?</mat-label>
            <mat-select #isRejectionRequestedSelect="matSelect" formControlName="isRejectionRequested">
                <mat-option [value]="'Yes'">Yes</mat-option>
                <mat-option [value]="'No'">No</mat-option>
            </mat-select>

            @if (reasonForm.get('isRejectionRequested')?.touched && reasonForm.get('isRejectionRequested')?.hasError('required')) {
            <mat-error>Please select Yes or No.</mat-error>
            }
        </mat-form-field>
        }

        @if (accountsStage){
        <mat-form-field class="fullLength">
            <mat-label>Would you like to reverse the entry of this transaction in Actionstep?</mat-label>
            <mat-select #isRPAReversalRequestedSelect="matSelect" formControlName="isRPAReversalRequested">
                <mat-option [value]="'Yes'">Yes</mat-option>
                <mat-option [value]="'No'">No</mat-option>
            </mat-select>

            @if (reasonForm.get('isRPAReversalRequested')?.touched && reasonForm.get('isRPAReversalRequested')?.hasError('required')) {
            <mat-error>Please select Yes or No.</mat-error>
            }
        </mat-form-field>

        @if (reasonForm.get('isRPAReversalRequested')?.value === 'Yes') {
        <div class="actionstep-url">
            <div class="link-wrapper">
                <a [href]="actionstepMatterUrl"
                   target="_blank"
                   rel="noopener noreferrer">
                    Open Matter in Actionstep ({{ matterNo }})
                </a>
                <button mat-icon-button
                        class="small-copy-btn"
                        [cdkCopyToClipboard]="actionstepMatterUrl"
                        (cdkCopyToClipboardCopied)="onUrlCopied()"
                        matTooltip="Copy link to clipboard"
                        matTooltipPosition="below">
                    <mat-icon>content_copy</mat-icon>
                </button>
            </div>
            <div class="warning-box">
                You must be logged into Actionstep under the same jurisdiction.
            </div>
        </div>

        <mat-form-field class="fullLength">
            <mat-label>Have you reversed the transaction from Actionstep?</mat-label>
            <mat-select #isTransactionReversedSelect="matSelect" formControlName="isTransactionReversed">
                <mat-option [value]="'Yes'">Yes</mat-option>
                <mat-option [value]="'No'">No</mat-option>
            </mat-select>

            @if (reasonForm.get('isTransactionReversed')?.touched && reasonForm.get('isTransactionReversed')?.hasError('required')) {
            <mat-error>Please select Yes or No.</mat-error>
            }
        </mat-form-field>

        @if(reasonForm.get('isTransactionReversed')?.value === 'No'){
        <mat-label>You have to reverse this transaction manually from Actionstep.</mat-label>
        }
        }
        }

    </form>
</mat-dialog-content>

<mat-dialog-actions align="end">
    <button mat-button (click)="cancel()">Cancel</button>
    <button mat-raised-button color="accent" (click)="submit()" [disabled]="reasonForm.invalid || (reasonForm.get('isRPAReversalRequested')?.value === 'Yes' && reasonForm.get('isTransactionReversed')?.value !== 'Yes')">Submit</button>
</mat-dialog-actions>
